import {
    AdvancedMarker,
    Pin,
    InfoWindow,
    useMap,
  } from "@vis.gl/react-google-maps";
  import { useCallback, useEffect, useMemo, useRef, useState } from "react";
  import { MarkerClusterer } from "@googlemaps/markerclusterer";
  import { fetchMarkerColour } from "../../services/Map";
  import moment from 'moment';

export default function Markers({ latlonData, selectedDimension }) {
    const map = useMap();
    const [selected, setSelected] = useState(null);
    const [markers, setMarkers] = useState({});
    const clusterer = useRef(null);
  
    // const handleMarkerClick = useCallback((latlon) => {
    //   setSelected(latlon);
    // }, []);

  
 
  
    const handleInfoWindowClose = useCallback(() => {
      setSelected(null);
    }, []);

    const renderInfoWindow = useMemo(() => {
      if (!selected) return null;
      return (
        <InfoWindow
          position={{ lat: selected.location.lat, lng: selected.location.lng }}
          onCloseClick={handleInfoWindowClose}
          className="map-info-window"
          headerContent={<b>School Info</b>}
          pixelOffset={[0, -35]}
        >
          <div>
           {selected.data.dealid !== null && <div><b>Deal ID:</b> {selected.data.dealid.split('.')[0] || 'N/A'}</div> }
           {selected.data.schname !== null && <div><b>School Name:</b> {selected.data.schname || 'N/A'}</div> }
           {selected.data.email !== null && <div><b>Area Manager :</b> {selected.data.email || 'N/A'}</div> }
            {selected.data.inside_sales !==null && <div><b>Inside Sales Manager:</b> {selected.data.inside_sales || 'N/A'}</div>}
           {selected.data.district !== null && <div><b>District:</b> {selected.data.district || 'N/A'}</div>}
            {selected.data.pin_code !== null && <div><b>Pincode:</b> {selected.data.pin_code || 'N/A'}</div>}
            {selected.data.state !== null && <div><b>State:</b> {selected.data.state || 'N/A'}</div>}
            {selected.data.relationship_w_lead !== null && <div><b>RL/W Lead:</b> {selected.data.relationship_w_lead || 'N/A'}</div>}
            {selected.data.relationship_w_pearson !== null && <div><b>RL/W Pearson: </b> {selected.data.relationship_w_pearson || 'N/A'}</div>}
           { selected.data.stage_category !==null && <div><b>Deal Category:</b> {selected.data.stage_category || 'N/A'}</div>}
            {selected.data.stagelabel !== null && <div><b>Deal Label:</b> {selected.data.stagelabel || 'N/A'}</div>}
           {selected.data.meeting_scheduled_date !== null &&  <div><b>Meeting Scheduled Date:</b> {selected.data.meeting_scheduled_date ? moment(selected.data.meeting_scheduled_date).format('DD/MM/YYYY') : 'N/A'}</div> }
           {selected.data.affiliation__dise !== null &&  <div><b>Affiliation:</b> {selected.data.affiliation__dise || 'N/A'}</div>}
           {selected.data.school_category !== null && <div><b>School Category:</b> {selected.data.school_category || 'N/A'}</div>}
          </div>
        </InfoWindow>
      );
    }, [selected, handleInfoWindowClose]);

    useEffect(() => {
      if (!map) return;
      if (!clusterer.current) {
        clusterer.current = new MarkerClusterer({ map, algorithmOptions:{maxZoom: 16} });
      }
    }, [map]);
  
    useEffect(() => {
      clusterer.current?.clearMarkers();
      clusterer.current?.addMarkers(Object.values(markers));
    }, [markers]);
  
    const setMarkerRef = (marker, key) => {
      if (marker && markers[key]) return;
      if (!marker && !markers[key]) return;
  
      setMarkers((prev) => {
        if (marker) {
          return { ...prev, [key]: marker };
        } else {
          const newMarkers = { ...prev };
          delete newMarkers[key];
          return newMarkers;
        }
      });
    };
  
    return (
      <>
        {latlonData.map((latlon) => (
          <AdvancedMarker
            position={{ lat: Number(latlon.data['lat']), lng: Number(latlon.data['lon']) }}
            key={latlon['key']}
            ref={(marker) => setMarkerRef(marker, latlon['key'])}
            onClick={(e) => setSelected(latlon)}
          >
            <Pin background={fetchMarkerColour(selectedDimension, latlon.data)} glyphColor={'#000'} borderColor={'#000'} />
            {selected && selected.key === latlon.key && renderInfoWindow}
            {/* {selected && (
              <InfoWindow
                position={{ lat: selected.location.lat, lng: selected.location.lng }}
                onCloseClick={() => setSelected(null)}
                className="map-info-window"
                headerContent={<b>School Info</b>}
                pixelOffset={[0, -25]}
              >
                <div>
                  <div><b>School Name:</b> {selected.data.schname}</div>
                  <div><b>District:</b> {selected.data.district}</div>
                  <div><b>Pincode:</b> {selected.data.pin_code}</div>
                  <div><b>State:</b> {selected.data.state}</div>
                  <div><b>RL/W Lead:</b> {selected.data.relationship_w_lead || 'N/A'}</div>
                  <div><b>RL/W Pearson:</b> {selected.data.relationship_w_pearson || 'N/A'}</div>
                  <div><b>Deal Category:</b> {selected.data.stage_category}</div>
                  <div><b>Deal Label:</b> {selected.data.stagelabel}</div>
                  <div><b>Meeting Scheduled Date:</b> {selected.data.meeting_scheduled_date ? moment(selected.data.meeting_scheduled_date).format('DD/MM/YYYY'): 'N/A'}</div>
                  <div><b>Affiliation:</b> {selected.data.affiliation__dise}</div>
                  <div><b>School Category:</b> {selected.data.school_category}</div>
                </div>
              </InfoWindow>
            )} */}
          </AdvancedMarker>
        ))}
      </>
    );
  };